import './index.scss'
import {
  defineComponent,
  onMounted,
  reactive,
  getCurrentInstance,
  ref,
  computed
} from '@vue/composition-api'
import {
  NPS_SCORE_TYPE,
  SCALE_MAX_SCORE_TYPE,
  STR_TYPE
} from '@/pages/Survey/SurveyManagement/components/SurveyContent/config'
import { useHistory, useSelector } from '@/utils/bhooks'
import i18n from '@/locales'
import { MessageBox } from '@gcommon/gcommon-ui'
import { getIsQuotedSurvey, getTopicCountries } from '@/services/survey'

const OptionSettings = defineComponent({
  name: 'OptionSettings',
  props: [
    'id',
    'type',
    'isAllowNull',
    'maxScore',
    'lastPageText',
    'nextPageText',
    'minScoreDesc',
    'maxScoreDesc',
    'scoreStyle',
    'customizeOption',
    'customizeOptionValue',
    'isRandomOrder',
    'optionLengthMoreThan',
    'optionLengthLessThan',
    'isRollback',
    'isAllowSubmit',
    'optionSettingItem',
    'format',
    'isEncryption',
    'textLessThan',
    'isAllowEdit',
    'maxAppendixNum',
    'smsEnable',
    'topics',
    'countryTopicOption',
    'isCountryTopicOption'
  ],
  setup(props, context) {
    const router = useHistory()
    let surveyId = router?.history.current.query.surveyId //问卷id
    const vm = getCurrentInstance()
    const { surveyDetail } = useSelector(({ surveyDetail }) => ({
      surveyDetail
    }))
    const { emit } = context
    //i18n 国际化
    const tran = function (initParam) {
      return vm?.proxy.$t(initParam) as string
    }

    const editData: any = computed(() => ({
      item: props.optionSettingItem?.item,
      index: props.optionSettingItem?.index
    }))

    const maxTextStr = (type) => {
      let max = ''
      switch (type) {
        case 4:
          max = '50'
          break
        case 10:
          max = '100'
          break
        case 11:
          max = '1000'
          break
        default:
      }
      return `${tran('survy.byte')}( ${tran('survy.maxNum')}${max} )`
    }

    const scoreLabelChange = async (value) => {
      if (value) {
        //判断是否有其他选中
        const obj = props.topics.find(
          (item) => item.topicSetting?.smsEnable && item.id !== props.id
        )
        if (obj) {
          MessageBox.confirm(
            '此问卷已配置短信评分选项，是否禁用原有选项并将本题设置为短信评分选项？',
            '',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              const topicData = JSON.parse(JSON.stringify(obj))
              topicData.topicSetting.smsEnable = false
              emit('updateOtherTopicSmsEnable', topicData)
              emit('changeSmsEnable', value)
            })
            .catch(() => {
              emit('changeSmsEnable', false)
            })
        } else {
          emit('changeSmsEnable', value)
        }
      } else {
        // 需要进行后端绑定校验
        const { data } = await getIsQuotedSurvey(surveyId)
        if (data) {
          MessageBox.confirm(
            '关闭该选项将影响短信评分，请确认：引用该问卷的调研，所配置的消息模板已关闭配置项“允许用户回复短信评分”',
            '',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              emit('changeSmsEnable', value)
            })
            .catch(() => {
              emit('changeSmsEnable', true)
            })
        } else {
          emit('changeSmsEnable', value)
        }
      }
    }

    const divisions = ref<
      Array<{
        countryName: string
        countryCode: string
      }>
    >([])

    onMounted(async () => {
      if (props.type === 21) {
        const { data } = await getTopicCountries()
        divisions.value = data || []
      }
    })

    return () => {
      return (
        <div class="survey_option_settings">
          <div class="overall-settings">
            <div class="title">{tran('survy.overallSettings')}</div>
            <el-form ref="overallFormRef">
              {props.isAllowNull?.toString() && (
                <el-form-item label={tran('survy.noneedans')}>
                  <el-switch
                    size="small"
                    value={props.isAllowNull}
                    onChange={(value) =>
                      emit('changeIsAllowNull', value)
                    }></el-switch>
                </el-form-item>
              )}

              {props.isCountryTopicOption && (
                <el-form-item>
                  <template slot="label">
                    <i
                      style="color:#f2616a;margin-right: 4px;"
                      class="topic-title-not-null">
                      *
                    </i>
                    <span>区域国家</span>
                  </template>
                  <el-select
                    size="small"
                    onInput={(value) => emit('changeDivision', value)}
                    value={props.countryTopicOption}
                    placeholder="请选择区域国家">
                    {divisions.value.map((sitem) => {
                      return (
                        <el-option
                          key={sitem.countryName}
                          label={sitem.countryName}
                          value={sitem.countryName}></el-option>
                      )
                    })}
                  </el-select>
                </el-form-item>
              )}

              {props.maxScore && (
                <el-form-item label={tran('survy.pointvalue')}>
                  <el-select
                    size="small"
                    onInput={(value) => emit('changeMaxScore', value)}
                    value={props.maxScore}
                    disabled={props.isAllowEdit}
                    placeholder={tran('survy.plcselect')}>
                    {SCALE_MAX_SCORE_TYPE.map((sitem) => {
                      return (
                        <el-option
                          key={sitem.value}
                          label={sitem.label}
                          value={sitem.value}></el-option>
                      )
                    })}
                  </el-select>
                </el-form-item>
              )}
              {[8, 14, 17, 18].includes(props.type) && (
                <el-form-item label={tran('survy.lowdes')}>
                  <el-input
                    size="small"
                    onInput={(value) => emit('changeMinScoreDesc', value)}
                    value={props.minScoreDesc}></el-input>
                </el-form-item>
              )}
              {[8, 14, 17, 18].includes(props.type) && (
                <el-form-item label={tran('survy.highdes')}>
                  <el-input
                    size="small"
                    onInput={(value) => {
                      emit('changeMaxScoreDesc', value)
                    }}
                    value={props.maxScoreDesc}></el-input>
                </el-form-item>
              )}
              {props.scoreStyle?.toString() && (
                <el-form-item label={tran('survy.style')}>
                  <el-select
                    size="small"
                    onInput={(value) => emit('changeScoreStyle', value)}
                    value={props.scoreStyle}
                    placeholder={tran('survy.plcselect')}>
                    {NPS_SCORE_TYPE.map((sitem) => {
                      return (
                        <el-option
                          key={sitem.value}
                          label={sitem.label}
                          value={sitem.value}></el-option>
                      )
                    })}
                  </el-select>
                </el-form-item>
              )}
              {props.customizeOption?.toString() && (
                <el-form-item label={tran('survy.customeOption')}>
                  <el-switch
                    size="small"
                    value={props.customizeOption}
                    onChange={(value) => {
                      emit('changeCustomizeOption', +value)
                    }}></el-switch>
                  {props.customizeOption && (
                    <el-input
                      size="small"
                      value={props.customizeOptionValue}
                      onInput={(value) => {
                        value = value.replace(/[0-9]/g, '')
                        emit('changeCustomizeOptionValue', value)
                      }}
                      placeholder={tran('survy.plccontent')}
                      maxlength={i18n.locale === 'en' ? '9' : '4'}></el-input>
                  )}
                </el-form-item>
              )}
              {props.isRandomOrder?.toString() && (
                <el-form-item label={tran('survy.freeone')}>
                  <el-switch
                    size="small"
                    onInput={(value) => emit('changeIsRandomOrder', value)}
                    value={props.isRandomOrder}></el-switch>
                </el-form-item>
              )}
              {[20].includes(props.type) && (
                <el-form-item class="score-label-form-item">
                  <slot name="label">
                    <div>
                      {tran('survy.scoreLabel')}
                      <el-tooltip
                        class="item"
                        effect="dark"
                        placement="top-start">
                        <div slot="content">
                          一份问卷只能配置一个短信评分，评分项内容将在推送内容中展示
                          <br />
                          示例： <br />
                          5. 非常满意
                          <br />
                          4. 满意
                          <br />
                          3. 一般
                          <br />
                          2. 不满意
                          <br />
                          1. 非常不满意
                          <br />
                          0. 未提供服务
                        </div>
                        <i
                          class="icon-question iconfont"
                          style={{
                            marginLeft: '3px',
                            color: 'rgba(0, 13, 31, 0.5)'
                          }}></i>
                      </el-tooltip>
                    </div>
                  </slot>
                  <div class="score-label-switch">
                    <el-switch
                      size="small"
                      value={props.smsEnable}
                      onChange={(value) => {
                        scoreLabelChange(value)
                      }}></el-switch>
                  </div>
                </el-form-item>
              )}
              {[2].includes(props.type) && (
                <el-form-item label={tran('survy.mostchose')}>
                  <el-input
                    class="option-num-input"
                    style={{ width: i18n.locale === 'en' ? '73%' : '90%' }}
                    type="number"
                    min={0}
                    onInput={(value) => {
                      emit('changeOptionLengthLessThan', value)
                    }}
                    size="small"
                    value={props.optionLengthLessThan}></el-input>
                  <span class="option-num">{tran('survy.item')}</span>
                </el-form-item>
              )}
              {[2].includes(props.type) && (
                <el-form-item label={tran('survy.lesschose')}>
                  <el-input
                    class="option-num-input"
                    style={{ width: i18n.locale === 'en' ? '73%' : '90%' }}
                    size="small"
                    type="number"
                    onInput={(value) =>
                      emit('changeOptionLengthMoreThan', value)
                    }
                    value={props.optionLengthMoreThan}></el-input>
                  <span class="option-num">{tran('survy.item')}</span>
                </el-form-item>
              )}
              {[4].includes(props.type) && (
                <el-form-item label={tran('survy.inputbox')}>
                  <el-select
                    clearable
                    onInput={(value) => {
                      emit('changeFormat', value)
                    }}
                    value={props.format}
                    size="small"
                    placeholder={tran('survy.chartype')}>
                    {STR_TYPE.map((sitem) => {
                      return (
                        <el-option
                          key={sitem.value}
                          label={sitem.label}
                          value={sitem.value}></el-option>
                      )
                    })}
                  </el-select>
                </el-form-item>
              )}
              {[4, 22, 23].includes(props.type) && (
                <el-form-item label={tran('survy.inputBoxEncrypt')}>
                  <el-switch
                    size="small"
                    value={props.isEncryption}
                    onChange={(value) =>
                      emit('changeIsEncryption', value)
                    }></el-switch>
                </el-form-item>
              )}
              {[4, 10, 11].includes(props.type) && (
                <el-form-item label={tran('survy.mostinput')}>
                  <el-input
                    class="fill-num-input"
                    size="small"
                    type="number"
                    min={0}
                    placeholder={maxTextStr(props.type)}
                    value={props.textLessThan}
                    onInput={(value) => {
                      emit('changeTextLessThan', value)
                    }}></el-input>
                </el-form-item>
              )}
              {[19].includes(props.type) && (
                <el-form-item label={tran('survy.mostUpload')}>
                  <el-input
                    class="fill-num-input"
                    size="small"
                    type="number"
                    min={0}
                    max={9}
                    placeholder={`${tran('survy.attachment')}( ${tran(
                      'survy.maxNum'
                    )}${9} )`}
                    value={props.maxAppendixNum}
                    onInput={(value) => {
                      emit('changeMaxUploadSize', value)
                    }}></el-input>
                </el-form-item>
              )}
            </el-form>
            {[5, 15].includes(props.type) && (
              <div class="overall-default">{tran('survy.noOverall')}</div>
            )}
          </div>
          <div class="option-settings">
            {![21, 22, 23].includes(props.type) && (
              <div class="title">
                {tran('survy.optionSettings')}
                {props.optionSettingItem && (
                  <span class="title-option">
                    {`${tran('survy.option')} ${
                      props.optionSettingItem.index + 1
                    } ${tran('survy.settings')}`}
                  </span>
                )}
              </div>
            )}

            <el-form ref="optionFormRef">
              {[1, 2, 3, 9, 12, 20].includes(props.type) && (
                <el-form-item label={tran('survy.fix')}>
                  <el-switch
                    size="small"
                    // value={optionSettingItem.item?.isFixedNo}
                    value={editData.value.item?.isFixedNo}
                    onChange={(value) => {
                      editData.value.item.isFixedNo = value
                      emit('changeOptionSettingItem', editData.value)
                    }}
                    disabled={!props.isRandomOrder}></el-switch>
                </el-form-item>
              )}
              {[2].includes(props.type) && (
                <el-form-item label={tran('survy.exclusive')}>
                  <el-switch
                    size="small"
                    value={editData.value.item?.isExclusive}
                    onChange={(value) => {
                      editData.value.item.isExclusive = value
                      emit('changeOptionSettingItem', editData.value)
                    }}
                    disabled={props.optionLengthMoreThan > 1}></el-switch>
                </el-form-item>
              )}
              {[1, 2, 20].includes(props.type) && (
                <el-form-item label={tran('survy.allowemp')}>
                  <el-switch
                    size="small"
                    value={editData.value.item?.isAddText}
                    onChange={(value) => {
                      editData.value.item.isAddText = value
                      emit('changeOptionSettingItem', editData.value)
                    }}></el-switch>
                </el-form-item>
              )}
              {[1, 2, 20].includes(props.type) && (
                <el-form-item label={tran('survy.noallowemp')}>
                  <el-switch
                    size="small"
                    value={editData.value.item?.isRequire}
                    onChange={(value) => {
                      editData.value.item.isRequire = value
                      emit('changeOptionSettingItem', editData.value)
                    }}
                    disabled={!editData.value.item?.isAddText}></el-switch>
                </el-form-item>
              )}
              {[1, 2, 20].includes(props.type) && (
                <el-form-item label={tran('survy.inputbox')}>
                  <el-select
                    clearable
                    value={editData.value.item?.format}
                    onChange={(value) => {
                      editData.value.item.format = value
                      emit('changeOptionSettingItem', editData.value)
                    }}
                    size="small"
                    disabled={!editData.value.item?.isAddText}
                    placeholder={tran('survy.chartype')}>
                    {STR_TYPE.map((sitem) => {
                      return (
                        <el-option
                          key={sitem.value}
                          label={sitem.label}
                          value={sitem.value}></el-option>
                      )
                    })}
                  </el-select>
                </el-form-item>
              )}
              {[1, 2, 20].includes(props.type) && (
                <el-form-item label={tran('survy.getpass')}>
                  <el-switch
                    size="small"
                    disabled={!editData.value.item?.isAddText}
                    value={editData.value.item?.isEncryption}
                    onChange={(value) => {
                      editData.value.item.isEncryption = value
                      emit('changeOptionSettingItem', editData.value)
                    }}></el-switch>
                </el-form-item>
              )}
              {[15].includes(props.type) && (
                <div>
                  <el-form-item label={tran('survy.aloback')}>
                    <el-switch
                      size="small"
                      onChange={(value) => emit('changeIsRollback', value)}
                      value={props.isRollback}></el-switch>
                  </el-form-item>
                  <el-form-item label={tran('survy.aloend')}>
                    <el-switch
                      size="small"
                      onChange={(value) => emit('changeIsAllowSubmit', value)}
                      value={props.isAllowSubmit}></el-switch>
                  </el-form-item>
                  <el-form-item label={tran('survy.beftextt')}>
                    <el-input
                      size="small"
                      onInput={(value) => emit('changeLastPageText', value)}
                      value={props.lastPageText}></el-input>
                  </el-form-item>
                  <el-form-item label={tran('survy.afttext')}>
                    <el-input
                      size="small"
                      value={props.nextPageText}
                      onInput={(value) =>
                        emit('changeNextPageText', value)
                      }></el-input>
                  </el-form-item>
                </div>
              )}
            </el-form>
            {[4, 5, 8, 10, 11, 14, 17, 18, 19].includes(props.type) && (
              <div class="option-default">{tran('survy.noOption')}</div>
            )}
          </div>
        </div>
      )
    }
  }
})
export default OptionSettings
